/*
  Buy 1 NanoGluco, Get 1 Free (client request 2026-10-21). Shopify's automatic "Buy X get Y" discount makes the
  second bottle free, but Shopify never puts that bottle in the cart. This script does, and only while Shopify
  really makes it free:
  - a one-time bottle that has just arrived (none before, 1 now) gets its partner; if Shopify does not then take a
    full bottle off, the partner goes back out and the script stops for the visit;
  - a partner this script added goes back out when the pair stops being free (discount paused or ended, or a code
    that can't combine wins), also at checkout, which waits until the cart is right;
  - a customer who lowers 2 to 1 keeps 1, and bottles a customer adds meanwhile stay: the script only ever puts in
    or takes out its one partner.
  Every change is saved before it is sent, so a lost response is finished, never repeated. While the partner is on its
  way the theme's loading bar runs and the open drawer shows a line for it; the drawer is redrawn from the same answer.
  Notes: snippets/CWC_bogo.liquid.
*/
(function () {
  var cfg = window.CWC_BOGO;
  if (!cfg || !cfg.variant || !window.fetch || window.__cwcBogo) return;
  window.__cwcBogo = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var settings = (window.themeVariables && window.themeVariables.settings) || {};
  var cartKey = 'cwc-bogo-' + cfg.variant;         // localStorage { token, qty, added, target } for the current cart
  var visitKey = 'cwc-bogo-visit-' + cfg.variant;  // sessionStorage { off, fixes: { token: tries } }
  var memory = { cart: null, visit: null };         // kept in step with storage, and used alone when storage is blocked
  var stored = true;
  var running = null;  // the cart change on its way; checkout waits for it
  var again = false;   // the cart changed meanwhile: look again when done
  var seen = 0;        // theme cart events so far; a drawer drawn from an older cart is drawn again
  var passUntil = 0;   // a checkout this script has just checked goes through

  function read(area, key) {
    try { return JSON.parse(window[area].getItem(key)); } catch (_) { stored = false; return null; }
  }
  function write(area, key, value) {
    try { window[area].setItem(key, JSON.stringify(value)); } catch (_) { stored = false; }
  }
  // added: true = the free partner this script put in; 'adding' / 'removing' = a change sent but not yet confirmed
  // (target = the bottle count it ends at); false = nothing of the script's in the cart.
  function cartState(token) {
    var saved = read('localStorage', cartKey) || memory.cart;
    return saved && saved.token === token ? saved : {};
  }
  function saveCart(token, qty, added, target) {
    memory.cart = { token: token, qty: qty, added: added, target: target };
    write('localStorage', cartKey, memory.cart);
  }
  function visit() {
    return read('sessionStorage', visitKey) || memory.visit || { off: false, fixes: {} };
  }
  function saveVisit(value) {
    memory.visit = value;
    write('sessionStorage', visitKey, value);
  }
  function turnOff() {
    var v = visit();
    v.off = true;
    saveVisit(v);
  }

  // One-time lines of the promotion bottle. A subscription line is never paired.
  function bottles(cart) {
    return (cart.items || []).filter(function (item) {
      return item.variant_id === cfg.variant && !item.selling_plan_allocation;
    });
  }
  function count(lines) {
    return lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }
  // Shopify splits the pair into two lines and puts the whole bottle price on the free one. Its type reads
  // "automatic" in cart/change.js but "" in cart.js, so only a code (or a manual discount) is ruled out here.
  function oneBottleFree(lines) {
    return lines.some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (allocation) {
        var type = (allocation.discount_application || {}).type;
        return type !== 'discount_code' && type !== 'manual' && type !== 'script' && allocation.amount >= item.original_price;
      });
    });
  }
  function needsFix(state, lines) {
    return state.added === 'adding' || state.added === 'removing' ||
      (state.added === true && count(lines) >= 2 && !oneBottleFree(lines));
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error(path + ' ' + response.status);
      return response.json();
    });
  }
  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  // Down to `target` bottles, one unit at a time from the last line. The aim is saved first, so a removal whose
  // response is lost is not repeated on top of itself.
  function shrinkTo(cart, target, steps) {
    var lines = bottles(cart);
    if (count(lines) <= target) {
      saveCart(cart.token, count(lines), false);
      return Promise.resolve(cart);
    }
    if ((steps || 0) >= 3) return Promise.reject(new Error('cart did not shrink'));
    saveCart(cart.token, count(lines), 'removing', target);
    var last = lines[lines.length - 1];
    var updates = {};
    updates[last.key] = last.quantity - 1;
    return post('cart/update.js', { updates: updates }).then(function (next) { return shrinkTo(next, target, (steps || 0) + 1); });
  }

  // Puts the cart right after anything left half done; resolves with the new cart, null when nothing had to change.
  // At most the one partner goes back out, so bottles the customer added meanwhile stay.
  function reconcile(cart) {
    var lines = bottles(cart);
    var quantity = count(lines);
    var state = cartState(cart.token);
    if (state.added === 'adding') {
      if (quantity >= 2 && oneBottleFree(lines)) { saveCart(cart.token, quantity, true); return Promise.resolve(null); }
      if (quantity >= 2) { turnOff(); return shrinkTo(cart, quantity - 1); }
    } else if (state.added === 'removing') {
      if (quantity > state.target) return shrinkTo(cart, quantity - 1);
    } else if (state.added === true && quantity >= 2 && !oneBottleFree(lines)) {
      turnOff();
      return shrinkTo(cart, quantity - 1);
    } else {
      return Promise.resolve(null);
    }
    saveCart(cart.token, quantity, false);
    return Promise.resolve(null);
  }

  function pair(cart) {
    var line = bottles(cart)[0];
    var mark = seen;
    var body = { id: line.key, quantity: 2 };
    // The drawer comes back with the same answer, so the bottle shows as soon as Shopify has added it.
    if (settings.pageType !== 'cart') body.sections = sectionList();
    saveCart(cart.token, 1, 'adding', 1);
    return post('cart/change.js', body).then(function (next) {
      var paired = bottles(next);
      if (count(paired) >= 2 && oneBottleFree(paired)) {
        saveCart(next.token, count(paired), true);
        next.cwcSeen = mark;
        return next;
      }
      // Not free in Shopify (discount paused or ended, a code that can't combine, or no stock): undo and stop. The
      // cart is read again first, so a bottle the customer added while this answer was on its way stays.
      turnOff();
      return getCart().then(function (latest) {
        return reconcile(latest).then(function (fixed) { return fixed || latest; });
      });
    });
  }

  // The sections the theme draws with a cart change (the drawer).
  function sectionList() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections.join(',');
  }

  // Draw the drawer from a cart read after the change: the script's own answer when no theme cart event came in while
  // it was out, otherwise a fresh read (and again if the theme drew a newer cart meanwhile).
  function render(cart, rounds) {
    if (settings.pageType === 'cart') {
      if (count(bottles(cart)) !== cfg.qty) window.location.reload();
      return Promise.resolve();
    }
    if (cart.sections && cart.cwcSeen === seen) {
      draw(cart);
      return Promise.resolve();
    }
    var mark = seen;
    return post('cart/update.js', { updates: {}, sections: sectionList() }).then(function (latest) {
      if (seen !== mark && (rounds || 0) < 3) return render(latest, (rounds || 0) + 1);
      draw(latest);
    });
  }
  function draw(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cwc-bogo', cart: cart } }));
  }

  // While a change is on its way: the theme's loading bar and, for the partner, a line for it in the open drawer.
  function loading(on) {
    document.documentElement.dispatchEvent(new CustomEvent(on ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true }));
    var row = !on && document.querySelector('.cwc-bogo-adding');
    if (row) row.remove();
  }
  function showAdding() {
    var link = document.querySelector('cart-drawer .cwc_cart__items a[href*="variant=' + cfg.variant + '"]');
    var line = link && link.closest('.cwc_cart__item');
    if (!running || !line || document.querySelector('.cwc-bogo-adding')) return;
    if (!document.getElementById('cwc-bogo-style')) {
      var style = document.createElement('style');
      style.id = 'cwc-bogo-style';
      style.textContent =
        '.cwc-bogo-adding{animation:cwc-bogo-in .25s ease-out both}' +
        '.cwc-bogo-adding .cwc_cart__line-media,.cwc-bogo-adding .cwc_cart__line-top{opacity:.6}' +
        '.cwc-bogo-adding__note{display:flex;align-items:center;gap:8px;margin:10px 0 0;font-size:13px;color:rgb(68,104,26)}' +
        '.cwc-bogo-adding__spinner{flex:none;width:14px;height:14px;border:2px solid currentColor;border-right-color:transparent;' +
        'border-radius:50%;animation:cwc-bogo-spin .7s linear infinite}' +
        '@keyframes cwc-bogo-spin{to{transform:rotate(360deg)}}' +
        '@keyframes cwc-bogo-in{from{opacity:0;transform:translateY(6px)}}' +
        '@media (prefers-reduced-motion:reduce){.cwc-bogo-adding,.cwc-bogo-adding__spinner{animation:none}}';
      document.head.appendChild(style);
    }
    var row = document.createElement('div');
    row.className = 'cwc_cart__item cwc-bogo-adding';
    row.setAttribute('role', 'status');
    row.innerHTML = '<div class="cwc_cart__line"><div class="cwc_cart__line-media"></div><div class="cwc_cart__line-body">' +
      '<div class="cwc_cart__line-top"><div class="cwc_cart__line-ident"><span class="cwc_cart__line-name"></span></div>' +
      '<div class="cwc_cart__line-prices"><span class="cwc_cart__line-price">FREE</span></div></div>' +
      '<p class="cwc-bogo-adding__note"><span class="cwc-bogo-adding__spinner" aria-hidden="true"></span>Adding your free bottle\u2026</p>' +
      '</div></div>';
    var image = line.querySelector('img');
    if (image) {
      var copy = image.cloneNode();
      copy.alt = '';
      copy.loading = 'eager';
      row.querySelector('.cwc_cart__line-media').appendChild(copy);
    }
    row.querySelector('.cwc_cart__line-name').textContent = link.textContent;
    line.insertAdjacentElement('afterend', row);
  }

  function start(task) {
    again = false;
    loading(true);
    running = Promise.resolve()
      .then(task)
      .catch(function () {
        // A request failed on the way (network, or Shopify refused it): read the real cart and finish the job.
        turnOff();
        return getCart().then(function (cart) {
          return reconcile(cart).then(function (next) { return next || cart; });
        });
      })
      .then(function (cart) { return cart ? render(cart) : null; })
      .catch(function () {}) // still unresolved: checkout checks again before it goes on
      .then(function () {
        running = null;
        loading(false);
        if (again) getCart().then(function (cart) { check(cart, true); }).catch(function () {});
      });
    return running;
  }

  // live: the cart changed on this page just now (not a page load).
  function check(cart, live) {
    if (!cart || !cart.items) return;
    if (running) { again = true; return; }
    var lines = bottles(cart);
    var quantity = count(lines);
    var state = cartState(cart.token);
    if (needsFix(state, lines)) {
      // At most two tries per visit; a fix that keeps failing is left to checkout, which checks again.
      var v = visit();
      v.fixes = v.fixes || {};
      if ((v.fixes[cart.token] || 0) >= 2) return;
      v.fixes[cart.token] = (v.fixes[cart.token] || 0) + 1;
      saveVisit(v);
      start(function () { return reconcile(cart); });
      return;
    }
    saveCart(cart.token, quantity, state.added === true && quantity >= 2);
    // Only a bottle that has just arrived (from none) gets its partner. Without storage a page load can't tell.
    if (visit().off || quantity !== 1 || lines.length !== 1 || state.qty >= 1 || (!live && !stored)) return;
    start(function () { return pair(cart); });
    // The drawer draws the theme's own cart change first; the line for the partner goes in after that.
    if (settings.pageType !== 'cart') window.setTimeout(showAdding, 0);
  }

  // Product forms, the collection/search grid and the cart drawer all announce their changes with cart:change.
  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    if (detail.baseEvent === 'cwc-bogo') return;
    seen++;
    check(detail.cart, true);
  });
  // The older collection grid section announces its adds with its own event.
  document.addEventListener('cwc:cart:updated', function () {
    seen++;
    getCart().then(function (cart) { check(cart, true); }).catch(function () {});
  });

  // Checkout: while a change is on its way, or a partner this script added is in the cart, read the cart first and
  // put it right. Window capture runs before the theme's own checkout check (document capture).
  function showError(button) {
    var message = document.querySelector('[data-promo-cart-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-promo-cart-error', '');
      message.setAttribute('role', 'alert');
      button.insertAdjacentElement('beforebegin', message);
    }
    message.textContent = "We couldn't update your cart. Please try again.";
  }
  window.addEventListener('submit', function (event) {
    var button = event.submitter;
    if (!button || button.name !== 'checkout' || Date.now() < passUntil) return;
    var state = read('localStorage', cartKey) || memory.cart || {};
    if (!running && state.added !== true && state.added !== 'adding' && state.added !== 'removing') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = event.target;
    if (form.hasAttribute('data-bogo-checking')) return;
    form.setAttribute('data-bogo-checking', '');
    button.setAttribute('aria-busy', 'true');
    Promise.resolve(running)
      .then(getCart)
      .then(function (cart) {
        return reconcile(cart).then(function (next) {
          var after = next || cart;
          if (needsFix(cartState(after.token), bottles(after))) throw new Error('cart not settled');
          // The cart page is left for checkout anyway; elsewhere the drawer shows the cart that is checked out.
          return next && settings.pageType !== 'cart' ? render(next) : null;
        });
      })
      .then(function () {
        passUntil = Date.now() + 8000;
        var current = form.isConnected ? form : document.querySelector('#cart-drawer form[action$="/cart"]');
        var currentButton = current && current.querySelector('[name="checkout"]');
        if (current && currentButton) current.requestSubmit(currentButton);
      })
      .catch(function () { showError(button); })
      .then(function () {
        form.removeAttribute('data-bogo-checking');
        button.removeAttribute('aria-busy');
      });
  }, true);

  // The cart this page was built with: a bottle added by a form post or a cart link, or a pair left from earlier.
  if (cfg.qty >= 1) {
    getCart().then(function (cart) { check(cart, false); }).catch(function () {});
  } else {
    var saved = read('localStorage', cartKey) || memory.cart;
    if (saved && saved.qty) saveCart(saved.token, 0, false);
  }
})();
